import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RegulatoryDocumentFormDataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type RegulatoryDocumentFormDataQuery = { __typename?: 'Query', documentSources?: Array<{ __typename?: 'DocumentSource', id: string, name: string }> | null };


export const RegulatoryDocumentFormDataDocument = gql`
    query RegulatoryDocumentFormData {
  documentSources {
    id
    name
  }
}
    `;

/**
 * __useRegulatoryDocumentFormDataQuery__
 *
 * To run a query within a React component, call `useRegulatoryDocumentFormDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegulatoryDocumentFormDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegulatoryDocumentFormDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useRegulatoryDocumentFormDataQuery(baseOptions?: Apollo.QueryHookOptions<RegulatoryDocumentFormDataQuery, RegulatoryDocumentFormDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegulatoryDocumentFormDataQuery, RegulatoryDocumentFormDataQueryVariables>(RegulatoryDocumentFormDataDocument, options);
      }
export function useRegulatoryDocumentFormDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegulatoryDocumentFormDataQuery, RegulatoryDocumentFormDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegulatoryDocumentFormDataQuery, RegulatoryDocumentFormDataQueryVariables>(RegulatoryDocumentFormDataDocument, options);
        }
export type RegulatoryDocumentFormDataQueryHookResult = ReturnType<typeof useRegulatoryDocumentFormDataQuery>;
export type RegulatoryDocumentFormDataLazyQueryHookResult = ReturnType<typeof useRegulatoryDocumentFormDataLazyQuery>;
export type RegulatoryDocumentFormDataQueryResult = Apollo.QueryResult<RegulatoryDocumentFormDataQuery, RegulatoryDocumentFormDataQueryVariables>;